import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LogElement } from '@models/order';
import {
  OrderLogDialogComponent,
  OrderLogDialogData,
} from '../order-log-dialog/order-log-dialog.component';

@Component({
  selector: 'app-last-editor-field',
  templateUrl: './last-editor-field.component.html',
  styleUrls: ['./last-editor-field.component.css'],
})
export class LastEditorFieldComponent {
  @Input() orderForm: FormGroup;

  constructor(private dialog: MatDialog) {}

  get latestLog(): LogElement | null {
    const logs = this.orderForm?.value?.log;
    if (!logs?.length) {
      return null;
    }
    return logs
      .slice()
      .sort(
        (a, b) =>
          new Date(b.date ?? 0).getTime() - new Date(a.date ?? 0).getTime()
      )[0];
  }

  get hasLogs(): boolean {
    return !!this.latestLog;
  }

  openLogDialog(): void {
    const logs = this.orderForm?.value?.log;
    if (!logs?.length) {
      return;
    }
    this.dialog.open<OrderLogDialogComponent, OrderLogDialogData>(
      OrderLogDialogComponent,
      {
        data: { logs },
        panelClass: 'order-log-dialog-panel',
      }
    );
  }
}
